import React from "react";
import { Modal } from '@flightstats/airframe-react';
import store from '../redux/store';
import { modalContentStyle } from "../components/modal/Modal";
import { Provider, useSelector } from "react-redux";

export const progressIncrement = (data: any) => {
  let progressObj = store.getState().progressReducer;
  let sumOfNumComplete = progressObj.numComplete + data.numComplete;
  store.dispatch({ type: 'progressData', response: {
    numComplete: sumOfNumComplete,
    percentageComplete: Math.round(((sumOfNumComplete * 1000) / progressObj.maxValue) * 0.1)
  }});
}

export const progressHide = (callback: any) => {
  setTimeout(() => {
    store.dispatch({ type: 'progressData', response: { 
      show: false,
      percentageComplete: 0,
      numComplete: 0,
      maxValue: 0
    } });
    callback && callback();
  }, 500);
};

export const progressShow = (data: any) => {
  store.dispatch({ type: 'progressData', response: {
    ...data,
    show: true,
    maxValue: data.maxValue
  } });
};

const ProgressModal: React.FC<any> = () => {
  const progressObj = useSelector((state: any) => state.progressReducer);
  return <Modal isOpen={progressObj.show} contentStyle={modalContentStyle}>
    <div className="issue-assign issue-resolution-modal modal-dialog modal-md">
      <div className="content">
        <div className="choices">
          <div className="row">
            <div className="col-md-12 percentage">
              {progressObj.percentageComplete}% ({progressObj.numComplete} of {progressObj.maxValue} {progressObj.processedStr})
            </div>
          </div>
        </div>
      </div>
    </div>
  </Modal>
}

const WrappedProgressModal: React.FC<any> = () => (
  <Provider store={store}>
    <ProgressModal />
  </Provider>
);

export default WrappedProgressModal;